/* eslint-disable no-param-reassign */
/**
 * @ngdoc service
 * @name locationUtils
 * @description
 * There's not other way to say it but "this is a hack", a well known hack that allows you to change
 * the current app route without refreshing the components. This comes in handy when for UX reasons
 * you need to change the current URL but you don't want to reload the current component, as it may
 * have some heavy stuff on its `$onInit`.
 *
 * @example
 * locationUtils.skipReload().path('your-new-path');
 *
 * @param {Service} $location  The service to extend.
 * @param {Object}  $rootScope The extended method will subscribe to the location change so it can
 *                             intercept the components refresh.
 * @param {Object}  $route     By overwriting this object `current` property, the components won't
 *                             refresh.
 * @param {Service} $timeout   If for some reason the event listener for the route change doesn't
 *                             get called on the next second, a timed function will unsubscribe the
 *                             extended method from the event.
 * @return {Service}
 * @memberof rootModule
 */
const locationUtils = ($location, $rootScope, $route, $timeout) => {
  'ngInject';

  $location.skipReload = () => {
    const lastRoute = $route.current;
    const unsubscribe = $rootScope.$on('$locationChangeSuccess', () => {
      $route.current = lastRoute;
      unsubscribe();
    });

    $timeout(() => unsubscribe(), 1);

    return $location;
  };

  return $location;
};

export default locationUtils;
